import {
    BreachEvent,
    createRegisterableComponent,
    DataLayerEventName,
} from '@news-mono/web-common'
import React, { useEffect } from 'react'
import { MessageBanner } from '../../banners/MessageBanner/MessageBanner'
import { packageOfferDetails } from './common'
import { BreachWallContent } from './components/BreachNotificationWrapper/BreachNotification/BreachWallContent/BreachWallContent'
import {
    StyledMessage,
    StyledTerms,
    StyledTitle,
} from './components/BreachNotificationWrapper/BreachNotification/BreachWallContent/BreachWallContent.styled'
import { WestRewardsMessage } from './components/BreachNotificationWrapper/shared-components/WestRewardsMessage/WestRewardsMessage'

export interface BreachScreenRegistrationProps {
    bannerMessage?: string
    breachCreativeName: string
    breachDeal: string
    title: string
    message?: string
    terms: string
}

export const BreachScreenRegistration = createRegisterableComponent(
    'breachscreen',
    (props: BreachScreenRegistrationProps, services) => {
        const is50percentOffDeal =
            props.breachDeal === 'COVIDDIG' || props.breachDeal === 'GOVAN50'

        const subscriptionPackages = packageOfferDetails('default')

        const eventPayload: BreachEvent['payload'] = {
            paywallType: 'freemium',
            leadDepth: 0,
            creative: 'registration wall - launch',
            breachScreenType: 'Registration - Inline',
            popupMethod: 'auto',
            deal: '',
            pricepoint: [],
        }

        // Fire the available event
        useEffect(() => {
            services.onEvent({
                type: DataLayerEventName.breachScreenAvailable,
                originator: 'breachscreen',
                payload: eventPayload,
            })
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [])

        return (
            <div data-testid="BreachScreen">
                {props.bannerMessage && (
                    <MessageBanner
                        icon="subscriber"
                        connector="solid-arrow"
                        onEvent={services.onEvent}
                    >
                        <p>{props.bannerMessage}</p>
                    </MessageBanner>
                )}

                <BreachWallContent
                    breachCreativeName={props.breachCreativeName}
                    breachDeal={props.breachDeal}
                    onEvent={services.onEvent}
                    title={() => {
                        if (is50percentOffDeal) {
                            return (
                                <React.Fragment>
                                    <StyledTitle>Limited Offer</StyledTitle>
                                    <StyledMessage>
                                        <p>Save over 50% for 8 weeks*</p>
                                    </StyledMessage>
                                </React.Fragment>
                            )
                        }
                        return (
                            <React.Fragment>
                                <StyledTitle>{props.title}</StyledTitle>
                                {props.message && (
                                    <StyledMessage>
                                        <p>{props.message}</p>
                                    </StyledMessage>
                                )}
                            </React.Fragment>
                        )
                    }}
                    terms={() => {
                        if (is50percentOffDeal) {
                            return (
                                <StyledTerms>
                                    *Valid for new subscribers only.
                                    {` ${breachDealTerms(props.breachDeal)}`}
                                    <br />
                                    T&Cs apply
                                </StyledTerms>
                            )
                        }

                        return null
                    }}
                    mediaBanner={() => {
                        return null
                    }}
                    subscriptionPackages={subscriptionPackages}
                />
                <WestRewardsMessage />
            </div>
        )
    },
)

function breachDealTerms(deal: string) {
    switch (deal) {
        case 'GOVAN50':
            return 'Offer ends 20 February 2021.'
        case 'BRE1DISC':
            return 'Offer ends 2 May 2021.'
        default:
            return ''
    }
}
